import { getApiBaseUrlForFetch } from "~/constants/common";
import { ROUTES } from "~/constants/routing";
import type { IXShareSelection } from "~/feature/chart/components/XShareDialog/types";
import type { IMarket } from "~/types/event";
import { getSiteOrigin } from "~/utils/getSiteOrigin";
import {
  buildShareCardPath,
  SHARE_CARD_CONSENSUS,
  SHARE_CARD_NONE,
  SHARE_CARD_PARAM,
} from "~/utils/shareCard";

const getSharedMarket = (
  group: IMarket[],
  selection: IXShareSelection
): IMarket | undefined =>
  selection.marketId
    ? group.find(({ id }) => id === selection.marketId)
    : group[0];

const getCardParam = (
  selection: IXShareSelection,
  withCard: boolean
): string | null => {
  if (!withCard) return SHARE_CARD_NONE;
  if (selection.marketId === null) return SHARE_CARD_CONSENSUS;

  return null;
};

export const getXShareUrl = (
  slug: string,
  selection: IXShareSelection,
  group: IMarket[],
  withCard: boolean
): string => {
  const market = getSharedMarket(group, selection);
  const path = ROUTES.event.createURL(slug, market?.id);
  const card = market && getCardParam(selection, withCard);

  return `${getSiteOrigin()}${path}${card ? `&${SHARE_CARD_PARAM}=${card}` : ""}`;
};

export const getXShareCardSrc = (
  group: IMarket[],
  selection: IXShareSelection
): string | null => {
  const market = getSharedMarket(group, selection);

  if (!market) {
    return null;
  }

  const mode = selection.marketId ? market.platform : SHARE_CARD_CONSENSUS;

  return `${getApiBaseUrlForFetch()}${buildShareCardPath(market.id, mode)}`;
};
